// extracted by mini-css-extract-plugin
module.exports = {"accountLocked":"AccountLocked_accountLocked__3dZa9","message":"AccountLocked_message__3ULR-"};